const filter = [
  {
    name: 'All',
    value: 'All'
  },  {
    name: 'Approved',
    value: 'Approved'
  },
  {
    name: 'Unapproved',
    value: 'Unapproved'
  },
  {
    name: 'Approved tours with unapproved assignments',
    value: 'ApprovedTours'
  },
];

export default filter;


// WEBPACK FOOTER //
// ./src/Components/Approval/utils/filter.js